<div
  #dropdown="ngbDropdown"
  ngbDropdown
  autoClose="true"
  (openChange)="onDropdownChange()"
  class="dropdown topbar-head-dropdown ms-1 header-item"
>
  <button
    type="button"
    ngbDropdownToggle
    class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
    id="page-header-notifications-dropdown"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <i class='bx bx-bell fs-22'></i>
    @if (allnotifications.length && allnotifications.length>0) {
      <span class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
        {{allnotifications.length || 0}}
        <span class="visually-hidden">unread messages</span>
      </span>
    }
  </button>
  <div ngbDropdownMenu class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-notifications-dropdown">

    <div
      class="dropdown-head rounded-top"
      [ngStyle]="{ 'background-color': titlesUseSureSimBlue ? '#47568C' : '#e9ecf1' }"
    >
      <div class="p-3">
        <div class="row align-items-center">
          @if (titlesUseSureSimBlue && (!curUser.branded || curUser.isUtelize)) {
            <div class="col-auto">
              <img
                alt="Logo"
                [src]="isPlatformModeInview ? 'assets/images/myinview-logo.png' : 'assets/images/SureSIM-Logo-Light-109.png'"
                [style]="isPlatformModeInview ? 'height: 30px;' : 'height: 30px;'"
              >
            </div>
          }
          <div class="col">
            <h6
              class="m-0 fs-16 fw-semibold"
              [ngStyle]="{ 'color': titlesUseSureSimBlue ? 'white' : 'black' }"
            >
              Notifications
            </h6>
          </div>
          <div class="col-auto dropdown-tabs">
            <span class="badge bg-light-subtle text-body fs-13"> {{allnotifications.length || 0}} New</span>
          </div>
        </div>
      </div>

      <div class="px-2 pt-2">
        <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav nav-tabs dropdown-tabs nav-tabs-custom" id="notificationItemsTab">
          <li [ngbNavItem]="1">
            <a ngbNavLink
              [ngClass]="{ 'text-black': nav.activeId===1 }"
              [ngStyle]="{ 'color': nav.activeId===1 ? 'black' : (titlesUseSureSimBlue ? 'white' : 'black') }"
            >
              All ({{allnotifications.length || 0}})
            </a>
            <ng-template ngbNavContent>
              <div class="tab-pane fade show active py-2 ps-2" id="all-noti-tab" role="tabpanel">
                <ngx-simplebar style="max-height: 300px; overflow-y: auto;">
                  <div class="pe-2">
                    @for(item of allnotifications;track $index){
                      <div class="text-reset notification-item d-block position-relative">
                        <div class="d-flex">
                          <div class="avatar-xs me-3">
                            <span
                              class="avatar-title bg-info-subtle rounded-circle fs-16"
                              [ngClass]="item.icon == 'bx-error' ? 'text-danger' : 'text-success'"
                            >
                              
                              <i class="bx {{item.icon}}"></i>
                            </span>
                          </div>
                          <div class="flex-grow-1">
                            <a style="cursor: pointer;" (click)="openCommunication(item.id)">
                              <h6 class="mt-0 mb-2 lh-base">{{item.subject}}</h6>
                            </a>
                            <p class="mb-0 fs-11 fw-medium text-muted">
                              <span><i class="mdi mdi-clock-outline me-1"></i>{{item.enteredDate | date:'EEEE dd/MM/yyyy HH:mm:ss':'UTC'}}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    } @empty {
                      <div class="tab-pane p-4" id="alerts-tab" role="tabpanel" aria-labelledby="alerts-tab">
                        <div class="d-flex flex-column align-items-center justify-content-center text-center pt-4 pb-5">
                          <i class="bx bx-bell text-primary" style="font-size: 40px; color: #3b506c;">
                          </i><h6 class="fs-18 fw-semibold lh-base mt-3">No new notifications</h6>
                        </div>
                      </div>
                    }

                    <div class="my-3 text-center">
                      <button
                        type="button"
                        class="btn dynamic-bg-btn"
                        [style.--btn-bg]="titlesUseSureSimBlue ? '#47568C' : '#e9ecf1'"
                        [style.color]="titlesUseSureSimBlue ? 'white' : 'black'"
                        (click)="viewAllNotifications()"
                      >
                        View @if (allnotifications && allnotifications.length>0) {Current & } Past Notifications
                      </button>
                    </div>

                  </div>
                </ngx-simplebar>
              </div>
            </ng-template>
          </li>
          <li [ngbNavItem]="2">
            <a ngbNavLink
              [ngClass]="{ 'text-black': nav.activeId===2 }"
              [ngStyle]="{ 'color': nav.activeId===2 ? 'black' : (titlesUseSureSimBlue ? 'white' : 'black') }"
            >
              Messages
            </a>
            <ng-template ngbNavContent>
              <div class="tab-pane fade show active py-2 ps-2" id="all-noti-tab" role="tabpanel">
                <ngx-simplebar style="max-height: 300px; overflow-y: auto;">
                  <div class="pe-2">
                    @for(item of messages;track $index){
                      <div class="text-reset notification-item d-block position-relative">
                        <div class="d-flex">
                          <div class="avatar-xs me-3">
                            <span
                              class="avatar-title bg-info-subtle rounded-circle fs-16"
                              [ngClass]="item.icon == 'bx-error' ? 'text-danger' : 'text-success'"
                            >
                              
                              <i class="bx {{item.icon}}"></i>
                            </span>
                          </div>
                          <div class="flex-grow-1">
                            <a style="cursor: pointer;" (click)="openCommunication(item.id)">
                              <h6 class="mt-0 mb-2 lh-base">{{item.subject}}</h6>
                            </a>
                            <p class="mb-0 fs-11 fw-medium text-muted">
                              <span><i class="mdi mdi-clock-outline me-1"></i>{{item.enteredDate | date:'EEEE dd/MM/yyyy HH:mm:ss':'UTC'}}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    } @empty {
                      <div class="tab-pane p-4" id="alerts-tab" role="tabpanel" aria-labelledby="alerts-tab">
                        <div class="d-flex flex-column align-items-center justify-content-center text-center pt-4 pb-5">
                          <i class="bx bx-envelope text-success" style="font-size: 40px; color: #3b506c;">
                          </i><h6 class="fs-18 fw-semibold lh-base mt-3">No new messages</h6>
                        </div>
                      </div>
                    }

                    <div class="my-3 text-center">
                      <button
                        type="button"
                        class="btn dynamic-bg-btn"
                        [style.--btn-bg]="titlesUseSureSimBlue ? '#47568C' : '#e9ecf1'"
                        [style.color]="titlesUseSureSimBlue ? 'white' : 'black'"
                        (click)="viewAllNotifications()"
                      >
                        View @if (messages && messages.length>0) {Current & } Past Notifications
                      </button>
                    </div>

                  </div>
                </ngx-simplebar>
              </div>
            </ng-template>
          </li>
          <li [ngbNavItem]="3">
            <a ngbNavLink
              [ngClass]="{ 'text-black': nav.activeId===3 }"
              [ngStyle]="{ 'color': nav.activeId===3 ? 'black' : (titlesUseSureSimBlue ? 'white' : 'black') }"
            >
              Alerts
            </a>
            <ng-template ngbNavContent>
              <div class="tab-pane fade show active py-2 ps-2" id="all-noti-tab" role="tabpanel">
                <ngx-simplebar style="max-height: 300px; overflow-y: auto;">
                  <div class="pe-2">
                    @for(item of alerts;track $index){
                      <div class="text-reset notification-item d-block position-relative">
                        <div class="d-flex">
                          <div class="avatar-xs me-3">
                            <span
                              class="avatar-title bg-info-subtle rounded-circle fs-16"
                              [ngClass]="item.icon == 'bx-error' ? 'text-danger' : 'text-success'"
                            >
                              
                              <i class="bx {{item.icon}}"></i>
                            </span>
                          </div>
                          <div class="flex-grow-1">
                            <a style="cursor: pointer;" (click)="openCommunication(item.id)">
                              <h6 class="mt-0 mb-2 lh-base">{{item.subject}}</h6>
                            </a>
                            <p class="mb-0 fs-11 fw-medium text-muted">
                              <span><i class="mdi mdi-clock-outline me-1"></i>{{item.enteredDate | date:'EEEE dd/MM/yyyy HH:mm:ss':'UTC'}}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    } @empty {
                      <div class="tab-pane p-4" id="alerts-tab" role="tabpanel" aria-labelledby="alerts-tab">
                        <div class="d-flex flex-column align-items-center justify-content-center text-center pt-4 pb-5">
                          <i class="bx bx-error text-danger" style="font-size: 40px; color: #3b506c;">
                          </i><h6 class="fs-18 fw-semibold lh-base mt-3">No new alerts</h6>
                        </div>
                      </div>
                    }
            
                    <div class="my-3 text-center">
                      <button
                        type="button"
                        class="btn dynamic-bg-btn"
                        [style.--btn-bg]="titlesUseSureSimBlue ? '#47568C' : '#e9ecf1'"
                        [style.color]="titlesUseSureSimBlue ? 'white' : 'black'"
                        (click)="viewAllNotifications()"
                      >
                        View @if (alerts && alerts.length>0) {Current & } Past Notifications
                      </button>
                    </div>
                    
                  </div>
                </ngx-simplebar>
              </div>
            </ng-template>
          </li>
        </ul>
      </div>

    </div>

    <div class="tab-content" id="notificationItemsTabContent">
      <div class="tab-content text-muted">
        <div [ngbNavOutlet]="nav"></div>
      </div>
    </div>
  </div>
</div>
